<template>
  <v-layout align-center column pt-1>
    <v-flex py-0
      ><v-row>
        <p v-if="loadMoreEnabled && totalItems > first" class="py-0">
          <v-row align="center">
            Showing first
            <v-menu top left>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on" color="primary" class="mx-1">
                  {{ first }}
                </v-btn>
              </template>

              <v-list>
                <v-list-item
                  v-for="index in limits"
                  :key="index"
                  @click="onLimitClick(index)"
                >
                  <v-list-item-title>{{ index }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            of {{ items.totalCount }}
          </v-row>
          <v-row align="center" justify="center" class="mt-1">
            <v-btn
              :disabled="loading"
              small
              @click="$emit('loadMore')"
              outlined
              color="secondary"
              :loading="loading"
            >
              Get more results
              <v-icon dark right>mdi-download</v-icon>
            </v-btn>
          </v-row>
        </p>
        <p v-else>{{ totalItems }} All data loaded...</p>
      </v-row>
    </v-flex>
    <code v-if="debug"> first: {{ first }}, </code>
  </v-layout>
</template>
<script>
import EventBus from "../../../store/event-bus";
export default {
  name: "GetMoreResults",
  props: {
    loadMoreEnabled: {
      type: Boolean,
      default: () => false,
    },
    first: {
      type: Number,
      default: () => 25,
    },
    totalItems: Number,
    items: Object,
    modelName: String,
    loading: {
      type: Boolean,
      default: () => false,
    },
  },

  data() {
    return {
      debug: false,
      selectedLimit: this.first,
      limits: [25, 50, 100, 200, 500, 1000],
    };
  },

  methods: {
    onInfiniteScroll() {
      this.$emit("loadMore");
    },
    addOnInfiniteScrollListener() {
      const listElm =
        document.querySelector(".v-data-table__wrapper") ||
        document.querySelector(".ag-body-viewport");
      if (listElm) {
        listElm.addEventListener("scroll", (e) => {
          const scrollOnBottom =
            Math.ceil(listElm.scrollTop) + listElm.clientHeight >=
            listElm.scrollHeight;

          if (scrollOnBottom) {
            if (
              this.loadMoreEnabled &&
              !this.loading &&
              this.loading != undefined
            ) {
              this.$emit("loadMore");
            }
          }
        });
      }
    },
    onLimitClick(limit) {
      //this.selectedLimit = limit;
      this.$emit("limitChange", limit);
    },
  },
  mounted() {
    // window.onscroll = () => {
    //   // const bottomOfWindow =
    //   //   document.documentElement.scrollTop + window.innerHeight ===
    //   //   document.documentElement.offsetHeight;
    //   const bottomOfWindow =
    //     window.innerHeight + window.pageYOffset >= document.body.offsetHeight;
    //   // console.log(
    //   //   window.innerHeight,
    //   //   window.pageYOffset,
    //   //   document.body.offsetHeight
    //   // );
    //   if (bottomOfWindow) {
    //     if (this.loadMoreEnabled && !this.loading) {
    //       this.$emit("loadMore");
    //     }
    //   }
    // };
    EventBus.$on("add-infinite-scroll", () => {
      setTimeout(() => {
        this.addOnInfiniteScrollListener();
      }, 1000);
    });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/gt/shared/GetMoreResults.vue